import { useEffect, useState } from "react";
import cookieCutter from "cookie-cutter";

export const CookieAccepted = () => {
	const [cookie, setCookie] = useState(false);
	const [componentMounted, setComponentMounted] = useState(false);

	// const setMode = (mode) => {
	//   cookieCutter.set("pd-cookie--law", mode);
	//   setCookie(mode);
	// };

	const setCookieTest = (name, value, expirationDays) => {
		const date = new Date();
		date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
		const expires = "expires=" + date.toUTCString();
		document.cookie = name + "=" + value + ";" + expires + ";path=/";
		setCookie(true);
	};

	const toggleCookie = () => {
		let body = document.body;
		let cookieLawElement = document.getElementById("pd-cookie-law");
		setCookieTest("pd-cookie--law", "true", 180);
		cookieLawElement.classList.add("accepted");
		body.classList.remove("pd-cookie__overflow");
	};

	useEffect(() => {
		let body = document.body;
		let cookieLawElement = document.getElementById("pd-cookie-law");
		let cookieLaw = cookieCutter.get("pd-cookie--law");

		if (cookieLaw === undefined) {
			body.classList.add("pd-cookie__overflow");
			cookieLawElement.classList.remove("accepted");
			// cookieCutter.set("pd-cookie--law", "", { expires: new Date(0) });
		} else {
			cookieLawElement.classList.add("accepted");
		}

		let KEYCODE_TAB = 9;
		let KEYCODE_ESCAPE = 27;

		// Function to trap tab movement to a specific container element
		function trapFocusInArtworkModal(el) {
			// Gather all focusable elements in a list
			let query =
				"a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='email']:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled]), [tabindex='0']";
			let focusableEls = el.querySelectorAll(query);
			let firstFocusableEl = focusableEls[0];
			let lastFocusableEl = focusableEls[focusableEls.length - 1];

			// Add the key listener to the modal container to listen for Tab,
			// Left Arrow, Right Arrow, Enter and Escape
			el.addEventListener("keydown", function (e) {
				let isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;
				// let isEscPressed = e.key === "Escape" || e.keyCode === KEYCODE_ESCAPE;

				// Define behaviour for Tab or Shift+Tab
				if (isTabPressed) {
					// Shift+Tab
					if (e.shiftKey) {
						if (document.activeElement === firstFocusableEl) {
							// Move keyboard focus to the last focusable element in the container
							lastFocusableEl.focus();
							e.preventDefault();
						}
					}

					// Tab
					else {
						if (document.activeElement === lastFocusableEl) {
							// Move keyboard focus to the first focusable element in the container
							firstFocusableEl.focus();
							e.preventDefault();
						}
					}
				}

				// Define behaviour for Escape
				// if (isEscPressed) {
				//   // This will close out the modal when the Escape key is pressed
				//   // by clicking the modal's close link/button
				//   el.querySelector("a").click();
				// }
			});
		}

		trapFocusInArtworkModal(cookieLawElement);

		setComponentMounted(true);
	}, []);

	return [cookie, toggleCookie, componentMounted];
};
